import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { prescriptionAPI } from "@/lib/prescription-api";
import {
  CreateReferProgramRequest,
  UpdateReferProgramRequest,
} from "@/types/prescription";

export const useReferProgram = (
  appointmentId: string,
  parentType: "prescription" | "meal_plan" = "prescription"
) => {
  const queryClient = useQueryClient();
  // Include parentType in queryKey to separate cache for doctor vs nutritionist
  const queryKey = ["refer-program", appointmentId, parentType];

  const query = useQuery({
    queryKey,
    queryFn: () => prescriptionAPI.getReferProgram(appointmentId, parentType),
    retry: false,
  });

  const createMutation = useMutation({
    mutationFn: (data: CreateReferProgramRequest) =>
      prescriptionAPI.createReferProgram(appointmentId, data),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, data);
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: UpdateReferProgramRequest;
    }) => prescriptionAPI.updateReferProgram(appointmentId, id, data),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, data);
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    create: createMutation.mutate,
    update: updateMutation.mutate,
    isCreating: createMutation.isPending,
    isUpdating: updateMutation.isPending,
  };
};
